export * from './SkipToContent';
//# sourceMappingURL=index.js.map